import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashTransfer from "../CashTransfer";
import ModelProxyClass from "./ModelProxyClass";
import CashAccount from "../CashAccount";
import Location from "../Location";
import AmountDetails from "../AmountDetails";
import FileAsset from "../FileAsset";


/**
 * @class CashTransferBase
 * @extends ModelBaseClass
 * @property {number} id (int64)
 * @property {number} tenantId (int64)
 * @property {'WithdrawalFromVault'|'WithdrawalFromBank'|'DepositToVault'|'DepositToBank'|'BetweenCollectors'|'RtFill'} type
 * @property {CashAccount} fromCashAccount
 * @property {CashAccount} toCashAccount
 * @property {Location} location
 * @property {number} countedAmount
 * @property {AmountDetails} countedDetails
 * @property {FileAsset} meterReceiptFileAsset
 * @property {Date} dateGamingDay (date only)
 * @property {Date} dateCreated (date and time)
 */
class CashTransferBase extends ModelBaseClass {
	/**
	 * @type {number} id (int64)
	 */
	id;
	/**
	 * @type {number} tenantId (int64)
	 */
	tenantId;
	/**
	 * @type {'WithdrawalFromVault'|'WithdrawalFromBank'|'DepositToVault'|'DepositToBank'|'BetweenCollectors'|'RtFill'} type
	 */
	type;
	/**
	 * @type {CashAccount} fromCashAccount
	 */
	fromCashAccount;
	/**
	 * @type {CashAccount} toCashAccount
	 */
	toCashAccount;
	/**
	 * @type {Location} location
	 */
	location;
	/**
	 * @type {number} countedAmount
	 */
	countedAmount;
	/**
	 * @type {AmountDetails} countedDetails
	 */
	countedDetails;
	/**
	 * @type {FileAsset} meterReceiptFileAsset
	 */
	meterReceiptFileAsset;
	/**
	 * @type {Date} dateGamingDay (date only)
	 */
	dateGamingDay;
	/**
	 * @type {Date} dateCreated (date and time)
	 */
	dateCreated;

	/**
	 * Instantiates a new instance of CashTransfer based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashTransfer}
	 */
	static create(genericObject) {
		const newCashTransfer = new CashTransfer();
		newCashTransfer.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashTransfer;
	}

	/**
	 * Instantiates a new array of CashTransfer based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashTransfer]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashTransferArray = [];
		genericArray.forEach(genericObject => {
			newCashTransferArray.push(CashTransfer.create(genericObject));
		});
		return newCashTransferArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('id', 'integer'),
	ModelBaseClass.createModelProperty('tenantId', 'integer'),
	ModelBaseClass.createModelProperty('type', 'string'),
	ModelBaseClass.createModelProperty('fromCashAccount', 'CashAccount'),
	ModelBaseClass.createModelProperty('toCashAccount', 'CashAccount'),
	ModelBaseClass.createModelProperty('location', 'Location'),
	ModelBaseClass.createModelProperty('countedAmount', 'float'),
	ModelBaseClass.createModelProperty('countedDetails', 'AmountDetails'),
	ModelBaseClass.createModelProperty('meterReceiptFileAsset', 'FileAsset'),
	ModelBaseClass.createModelProperty('dateGamingDay', 'datetime'),
	ModelBaseClass.createModelProperty('dateCreated', 'datetime'),
];

export default CashTransferBase;
